(function () {
  'use strict';
  function overlaps(a, b) {
    return a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 &&
      a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }
  function shouldClear(widget, controls, protectedFocus) {
    return !protectedFocus && !!widget && controls.some(function (control) {
      return overlaps(widget, control);
    });
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { overlaps: overlaps, shouldClear: shouldClear };
    return;
  }
  var body = document.body;
  var isHomepage = body.classList.contains('template-index');
  var isCollectionPage = Array.prototype.some.call(body.classList, function (className) {
    return className === 'template-collection' || className.indexOf('template-collection-') === 0;
  });
  if ((!isCollectionPage && !isHomepage) || !window.MutationObserver) return;
  var selectors = isHomepage ? '.slideshow__caption, .slideshow__slide-image, .slideshow .flickity-button, .hsbd-autoplay-controls, .mobile__search--container, .hsbd-simply-carousel__copy, .image--with-text .section--caption, .hsbd-stock-shelf__heading, .hsbd-size-status, .hsbd-stock-shelf__controls button, .hsbd-stock-shelf__browse a' : '.mobile__search--container, .hsbd-simply-carousel__copy, .hsbd-hub-hero, .hsbd-hub-intro, .hsbd-hub-category-tile, .hsbd-hub-group__title, .hsbd-stock-shelf__heading, .hsbd-stock-shelf__card, .hsbd-stock-shelf__browse, .hsbd-hub-results-heading, .hsbd-size-status, .hsbd-stock-shelf__controls button, .pad-hub-card, .hsbd-arrival-shelves__nav, .hsbd-arrival-shelves__nav a, .hsbd-arrival-shelf__heading, .hsbd-arrival-shelf__heading button, [data-hsbd-arrival-filters], [data-hsbd-arrival-filters] *, .collection__page--full-width-filters, #main-collection-product-grid .product-index, #main-collection-product-grid button, #main-collection-product-grid summary, #main-collection-product-grid input, #main-collection-product-grid select';
  var shadowRoots = new WeakSet();
  var shadowChanges = new MutationObserver(schedule);
  var pending = false;
  var widgetSizes = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  var sizedWidgets = new WeakSet();
  function scan() {
    schedule();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }
  function chatActivator(root) {
    if (!root) return null;
    if (!shadowRoots.has(root)) {
      shadowRoots.add(root);
      shadowChanges.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'open']});
    }
    var activator = root.querySelector('[part~="activator"]');
    if (activator) return activator;
    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      if (!elements[i].shadowRoot) continue;
      activator = chatActivator(elements[i].shadowRoot);
      if (activator) return activator;
    }
    return null;
  }
  function update() {
    pending = false;
    var controls = [];
    document.querySelectorAll(selectors).forEach(function (element) {
      if (!element.isConnected || element.disabled || element.getClientRects().length === 0) return;
      var style = window.getComputedStyle(element);
      if (style.visibility !== 'visible' || style.display === 'none') return;
      var rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return;
      controls.push(rect);
    });
    var host = document.querySelector('shopify-chat');
    var activator = host && chatActivator(host.shadowRoot);
    var rewards = document.getElementById('smile-lite-launcher-frame') || document.getElementById('smile-ui-lite-launcher-frame-container');
    if (widgetSizes) [activator, rewards].forEach(function (widget) {
      if (widget && !sizedWidgets.has(widget)) {
        sizedWidgets.add(widget);
        widgetSizes.observe(widget);
      }
    });
    var active = document.activeElement;
    var chatProtected = !!host && (active === host || !!(activator && activator.getAttribute('aria-expanded') === 'true'));
    var rewardsProtected = !!rewards && (active === rewards || rewards.contains(active));
    body.classList.toggle('hsbd-clear-chat-launcher', shouldClear(activator && activator.getBoundingClientRect(), controls, chatProtected));
    body.classList.toggle('hsbd-clear-rewards-launcher', shouldClear(rewards && rewards.getBoundingClientRect(), controls, rewardsProtected));
  }
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', scan);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  var mutation = new MutationObserver(scan);
  mutation.observe(body, { childList: true, subtree: true });
  scan();
}());
